import {ChangeDetectionStrategy, Component, input, output, TemplateRef, viewChild} from "@angular/core"
import {CdkMenu, CdkMenuItem} from "@angular/cdk/menu"

export type AssetMenuAction = {
    id: string
    label: string
    icon?: string
    variant?: "default" | "destructive"
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-asset-actions-menu",
    templateUrl: "./asset-actions-menu.component.html",
    styleUrls: ["./asset-actions-menu.component.scss"],
    imports: [CdkMenu, CdkMenuItem],
})
export class AssetActionsMenuComponent {
    readonly $actions = input.required<AssetMenuAction[]>({alias: "actions"})
    readonly action = output<string>()
    readonly menu = viewChild.required<TemplateRef<unknown>>("menu")
}
